import React, { useState, useEffect } from "react";
import Sidebar from "./components/Sidebar";
import WalletConnectButton from "./components/WalletConnectButton";
import SwapCard from "./components/SwapCard";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import ErrorBoundary from "./components/ErrorBoundary";

function App() {
  const [walletAddress, setWalletAddress] = useState(null); // Ensure safe null handling
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isWalletModalOpen, setIsWalletModalOpen] = useState(false);
  const [scale, setScale] = useState(1); // Track scale dynamically
  const [sidebarScale, setSidebarScale] = useState(1);

  useEffect(() => {
    const updateScale = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
  
      const isLandscape = width > height;
  
      if (isLandscape) {
        // Landscape scaling
        if (width < 480) {
          setScale(0.5);
        } else if (width < 768) {
          setScale(0.55);
        } else if (width < 845) {
          setScale(0.6);
        } else if (width < 883) {
          setScale(0.55);
        } else if (width < 916) {
          setScale(0.65);
        } else if (width < 933) {
          setScale(0.7);
        } else if (width < 1024) {
          setScale(0.8);
        } else if (width < 1440) {
          setScale(0.9);
        } else {
          setScale(1.25);
        }
      } else {
        // Portrait scaling
        if (width < 320) {
          setScale(0.7);
        } else if (width < 360) {
          setScale(0.75);
        } else if (width < 376) {
          setScale(0.8);
        } else if (width < 415) {
          setScale(0.85);
        } else if (width < 480) {
          setScale(0.9);
        } else if (width < 540) {
          setScale(0.95);
        } else if (width < 640) {
          setScale(1);
        } else if (width < 768) {
          setScale(1.05);
        } else if (width < 1024) {
          setScale(1.1);
        } else {
          setScale(1.2);
        }
      }
  
      // Adjust Sidebar scaling
      if (isLandscape) {
        if (width < 480) {
          setSidebarScale(0.7);
        } else if (width < 768) {
          setSidebarScale(0.8);
        } else if (width < 1024) {
          setSidebarScale(1);
        } else {
          setSidebarScale(1);
        }
      } else {
        if (width < 480) {
          setSidebarScale(0.8);
        } else if (width < 768) {
          setSidebarScale(0.9);
        } else if (width < 1024) {
          setSidebarScale(1.05);
        } else {
          setSidebarScale(1.1);
        }
      }
    };
  
    // Initialize scale and add event listener
    updateScale();
    window.addEventListener("resize", updateScale);
  
    // Cleanup on unmount
    return () => window.removeEventListener("resize", updateScale);
  }, []);
  

  // Centralized toggle functions
  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
    if (!isSidebarOpen) setIsWalletModalOpen(false); // Ensure Wallet Modal closes
  };

  const toggleWalletModal = () => {
    setIsWalletModalOpen((prev) => !prev);
    if (!isWalletModalOpen) setIsSidebarOpen(false); // Ensure Sidebar closes
  };

    return (
      <div className="relative flex app">
        
        {/* Sidebar */}
        <div
    className="transform"
    style={{
      transform: `scale(${sidebarScale})`,
      transformOrigin: "top left",
      position: "fixed",
      top: "2vh", // Adjust dynamically if needed for specific resolutions
      left: "2vw",
      zIndex: isSidebarOpen ? 40 : 30,
    }}
  >
    <Sidebar isExpanded={isSidebarOpen} toggleSidebar={toggleSidebar} />
  </div>

  <div
    className="transform"
    style={{
      transform: `scale(${sidebarScale})`,
      transformOrigin: "top right",
      position: "fixed",
      top: "2vh", // Match the Sidebar's top position
      right: "2vw",
      zIndex: isWalletModalOpen ? 50 : 30,
    }}
  >
    <WalletConnectButton
      walletAddress={walletAddress}
      setWalletAddress={setWalletAddress}
      isExpanded={isWalletModalOpen}
      toggleWalletModal={toggleWalletModal}
    />
  </div>

  
      {/* Main Content */}
      <div className="flex flex-col w-full h-screen bg-gray-800 main-content">
        <div className="box-border flex items-center justify-center w-full min-h-screen px-4 pt-10">
          <ErrorBoundary>
            <div
              className="transform"
              style={{ scale: scale }} // Apply scale only to SwapCard
            >
              <SwapCard walletAddress={walletAddress || ""} />
            </div>
          </ErrorBoundary>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} theme="dark" />
    </div>
    
  );
}

export default App;
